import { Role } from './../Models/Role/Role';
import { Component, OnInit } from '@angular/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AuthService } from '../shared/services/auth.service';
import { User } from '../Models/User/User';
import { ModalController } from '@ionic/angular';
import { UserInformationPage } from './pages/user-information/user-information.page';

@Component({
  selector: 'app-dynamic',
  templateUrl: './dynamic.page.html',
  styleUrls: ['./dynamic.page.scss'],
})
export class DynamicPage implements OnInit {
  public user: User = null;

  public appPages = [
    { title: 'Clients', url: '/app/clients', icon: 'people' },
    { title: 'Deals', url: '/app/deals', icon: 'home' },
    {
      title: 'Conveyancy',
      url: '/app/conveyancy-dashboard',
      icon: 'file-tray-full',
    },
    { title: 'Financial Analysis', url: '/app/finance', icon: 'wallet' },
    { title: 'Reports', url: '/app/reports', icon: 'document-text' },
     { title: 'Documents', url: '/app/documents', icon: 'documents-outline' },
    { title: 'Agent', url: '/app/agent-dashboard', icon: 'person' },
  ];

  public bottomAnchoredAppPages = [
    { title: 'User Information', url: '/app/user-information', icon: 'lock-closed-outline' },
    { title: 'Manage', url: '/app/manage', icon: 'settings' },
    { title: 'Logout', url: '/login', icon: 'log-out' },
  ];

  public showSideMenu = true;
  public modalController: ModalController;
  imports: [NgxDatatableModule];

  constructor(public authService: AuthService) { }

  ngOnInit() {
    this.getUser()
  }

  private getUser(): void {
    this.user = this.authService.getActiveUser();
  }

  public logOut(): void {
    this.authService.clearSession();


  }

  
}